<template>
	<div class="quill-editor">
		<slot name="toolbar"></slot>
		<div>
			<div :style="{'height': minHeight + 'px'}" ref="editor"></div>
		</div>
	</div>
</template>

<script>
import _Quill from 'quill'
import defaultOptions from '@/modules/webEditor/options'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

const Quill = window.Quill || _Quill
// pollfill
if (typeof Object.assign != 'function') {
	Object.defineProperty(Object, 'assign', {
		value(target, varArgs) {
			if (target == null) {
				throw new TypeError('Cannot convert undefined or null to object')
			}
			const to = Object(target)
			for (let index = 1; index < arguments.length; index++) {
				const nextSource = arguments[index]
				if (nextSource != null) {
					for (const nextKey in nextSource) {
						if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
							to[nextKey] = nextSource[nextKey]
						}
					}
				}
			}
			return to
		},
		writable: true,
		configurable: true
	})
}

export default {
	name: 'webEditor',
	data() {
		return {
			_options: {},
			_content: '',
			defaultOptions
		}
	},
	props: {
		content: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		options: {
			type: Object,
			required: false,
			default: () => ({})
		},
		globalOptions: {
			type: Object,
			required: false,
			default: () => ({})
		},
		minHeight: {
			type: Number,
			defalut: 400
		}
	},
	mounted() {
		this.initialize();
	},
	beforeDestroy() {
		this.quill = null;
		delete this.quill;
	},
	methods: {
		// init Editor instance
		initialize() {
			if (this.$el) {
				
				// Option
				this._options = Object.assign({}, this.defaultOptions, this.globalOptions, this.options);

				// Instance
				this.quill = new Quill(this.$refs.editor, this._options);

				this.quill.enable(false);

				// Set editor content
				if (this.value || this.content) {
					this.quill.pasteHTML(this.value || this.content);
				}

				// Disabled editor
				if (!this.disabled) {
					this.quill.enable(true);
				}

				// Mark model as touched if editor lost focus
				this.quill.on('selection-change', range => {
					if (!range) {
						this.$emit('blur', this.quill);
					} else {
						this.$emit('focus', this.quill);
					};
				})

				// Update model if text changes
				this.quill.on('text-change', (delta, oldDelta, source) => {
					let html = this.$refs.editor.children[0].innerHTML;
					const quill = this.quill;
					const text = this.quill.getText();
					if (html === '<p><br></p>') html = ''
					this._content = html
					this.$emit('input', this._content)
					this.$emit('change', { html, text, quill })
				});

				// Emit ready event
				this.$emit('ready', this.quill);

				// 이미지 업로드 이벤트
				this.quill.getModule('toolbar').addHandler('image', () => {
					if (this.disabled) {
						return false;
					}
					this.$emit('imageUpload', this.quill);
				});

				// 비디오 업로드 이벤트 - 아직..
				this.quill.getModule('toolbar').addHandler('video', () => {
					if (this.disabled) {
						return false;
					}
					this.$emit('videoUpload', this.quill);
				});

			}
		}
	},
	watch: {
		// Watch content change
		content(newVal, oldVal) {
			if (this.quill) {
				if (newVal && newVal !== this._content) {
					this._content = newVal;
					this.quill.pasteHTML(newVal);
				} else if(!newVal) {
					this.quill.setText('');
				}
			}
		},
		// Watch content change
		value(newVal, oldVal) {
			if (this.quill) {
				if (newVal && newVal !== this._content) {
					this._content = newVal;
					this.quill.pasteHTML(newVal);
				} else if(!newVal) {
					this.quill.setText('');
				}
			}
		},
		// Watch disabled change
		disabled(newVal, oldVal) {
			const elToolbar = document.getElementsByClassName('ql-toolbar ql-snow')[0];
			const elContainer = document.getElementsByClassName('ql-container ql-snow')[0];

			if (this.quill) {
				this.quill.enable(!newVal);
			}

			if (newVal) {
				if (elToolbar) {
					elToolbar.classList.add('displayNone');
				}
				elContainer.classList.add('bordt1');
			} else {
				if (elToolbar) {
					elToolbar.classList.remove('displayNone');
					elToolbar.classList.add('displayBlock');
					elContainer.classList.remove('bordt1');
				}
			}
		}
	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/webEditor/WebEditor.vue